import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { TemplateModule } from 'src/app/template/template.module';

import { TutorDetailComponent } from './components/tutor-detail/tutor-detail.component';
import { TutorEditComponent } from './components/tutor-edit/tutor-edit.component';
import { TutorNewComponent } from './components/tutor-new/tutor-new.component';
import { TutorService } from './services/tutor.service';
import { TutorInfoComponent } from './pages/tutor-info/tutor-info.component';
import { TutorEditionComponent } from './pages/tutor-edition/tutor-edition.component';

@NgModule({

    declarations: [

        TutorDetailComponent,
        TutorEditComponent,
        TutorNewComponent,
        TutorInfoComponent,
        TutorEditionComponent

    ],

    imports: [
        CommonModule,
        SharedModule,
        TemplateModule
    ],

    exports: [

        TutorDetailComponent,
        TutorEditComponent,
        TutorNewComponent

    ],

    providers: [

        TutorService

    ]

})
export class TutorsModule { }
